export const MAP_OPTIONS = {
  fullscreenControl: false,
  streetViewControl: false,
  mapTypeControl: false,
  zoomControl: false,
  clickableIcons: false,
}

export const MAX_FRACTIONAL_PART = 10

export const libraries: 'places'[] = ['places']
